// import React, { useState, useRef, useEffect } from "react";
// import { responses } from "./botresponse";
// import "./aikyambot.css";
// import chat from "../assets/chat.png";

// const AikyamBot = () => {
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [isOpen, setIsOpen] = useState(false);
//   const [isTyping, setIsTyping] = useState(false);
//   const messagesEndRef = useRef(null);
//   const inputRef = useRef(null);
//   const containerRef = useRef(null); // ✅ ref instead of querySelector

//   // ✅ visualViewport keyboard handler — inside useEffect, not at component root
//   useEffect(() => {
//     if (!isOpen) return; // only run when chat is open

//     const container = containerRef.current; // ✅ copy ref to local variable

//     const handleViewport = () => {
//       if (!container || !window.visualViewport) return;

//       const keyboardOpen =
//         window.visualViewport.height < window.screen.height * 0.75;

//       if (keyboardOpen) {
//         const availableHeight = window.visualViewport.height - 12;
//         container.style.height = availableHeight + "px";
//         container.style.top = "6px";
//         container.style.bottom = "auto";
//       } else {
//         // Reset — let CSS take over
//         container.style.height = "";
//         container.style.top = "";
//         container.style.bottom = "";
//       }
//     };

//     if (window.visualViewport) {
//       window.visualViewport.addEventListener("resize", handleViewport);
//     }

//     // Cleanup when chat closes or component unmounts
//     return () => {
//       if (window.visualViewport) {
//         window.visualViewport.removeEventListener("resize", handleViewport);
//       }
//       // Reset styles on close
//       if (container) {
//         container.style.height = "";
//         container.style.top = "";
//         container.style.bottom = "";
//       }
//     };
//   }, [isOpen]); // ✅ re-runs whenever chat opens/closes

//   // Auto-scroll to bottom when new messages arrive
//   useEffect(() => {
//     scrollToBottom();
//   }, [messages, isTyping]);

//   // Focus input when chat opens
//   useEffect(() => {
//     if (isOpen && inputRef.current) {
//       inputRef.current.focus();
//     }
//   }, [isOpen]);

//   // Add welcome message when chat first opens
//   useEffect(() => {
//     if (isOpen && messages.length === 0) {
//       setTimeout(() => {
//         setMessages([
//           {
//             sender: "bot",
//             text: "Hello! I'm AikyamBot 🤖 Welcome! How can I assist you today?",
//             timestamp: new Date(),
//           },
//         ]);
//       }, 500);
//     }
//   }, [isOpen, messages.length]);

//   const scrollToBottom = () => {
//     messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
//   };

//   const getBotResponse = (userInput) => {
//     const normalizedInput = userInput.toLowerCase().trim();

//     if (responses[normalizedInput]) {
//       return responses[normalizedInput];
//     }

//     const keys = Object.keys(responses);
//     for (const key of keys) {
//       if (normalizedInput.includes(key) || key.includes(normalizedInput)) {
//         return responses[key];
//       }
//     }

//     return responses.default;
//   };

//   const sendMessage = async () => {
//     if (!input.trim()) return;
//     const userMsg = {
//       sender: "user",
//       text: input.trim(),
//       timestamp: new Date(),
//     };

//     setMessages((prev) => [...prev, userMsg]);
//     setInput("");
//     setIsTyping(true);

//     const typingDelay = Math.random() * 1000 + 800;

//     setTimeout(() => {
//       const botResponse = getBotResponse(userMsg.text);
//       const botMsg = {
//         sender: "bot",
//         text: botResponse,
//         timestamp: new Date(),
//       };

//       setMessages((prev) => [...prev, botMsg]);
//       setIsTyping(false);
//     }, typingDelay);
//   };

//   const handleKeyPress = (e) => {
//     if (e.key === "Enter" && !e.shiftKey) {
//       e.preventDefault();
//       sendMessage();
//     }
//   };

//   const toggleChat = () => {
//     setIsOpen(!isOpen);
//   };

//   const formatTime = (date) => {
//     return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
//   };

//   return (
//     <div className="aikyambot-wrapper">
//       {/* Floating Button */}
//       {!isOpen && (
//         <button
//           id="aikyam-chat-button"
//           className="chat-toggle"
//           onClick={toggleChat}
//           aria-label="Open AikyamBot chat"
//         >
//           <img src={chat} alt="chat" className="chat-icon" />
//           <span>AikyamBot</span>
//         </button>
//       )}

//       {/* Chat Window */}
//       {isOpen && (
//         <div className="chatbot-container" ref={containerRef}> {/* ✅ ref attached */}
//           <div className="chat-header">
//             <div className="bot-name">
//               <span>🤖 AikyamBot</span>
//               <div className="status-indicator" title="Online"></div>
//             </div>
//             <button
//               className="close-btn"
//               onClick={toggleChat}
//               aria-label="Close chat"
//             >
//               ✕
//             </button>
//           </div>

//           <div className="chat-messages">
//             {messages.length === 0 && (
//               <div className="welcome-message">Starting conversation...</div>
//             )}

//             {messages.map((msg, index) => (
//               <div key={index} className={`message ${msg.sender}`}>
//                 <div className="message-content">{msg.text}</div>
//                 <div className="message-time">{formatTime(msg.timestamp)}</div>
//               </div>
//             ))}

//             {isTyping && (
//               <div className="message bot">
//                 <div className="typing-indicator">
//                   <div className="typing-dots">
//                     <span></span>
//                     <span></span>
//                     <span></span>
//                   </div>
//                 </div>
//               </div>
//             )}

//             <div ref={messagesEndRef} />
//           </div>

//           <div className="chat-input">
//             <input
//               ref={inputRef}
//               type="text"
//               value={input}
//               onChange={(e) => setInput(e.target.value)}
//               onKeyDown={handleKeyPress}
//               placeholder="Type your message..."
//               disabled={isTyping}
//               maxLength={500}
//             />
//             <button
//               className="send-btn"
//               onClick={sendMessage}
//               disabled={!input.trim() || isTyping}
//               aria-label="Send message"
//             >
//               {isTyping ? "..." : "➤"}
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AikyamBot;


import React from "react";
import "./aikyambot.css";
import chat from "../assets/chat.png";

const AikyamBot = () => {
  return (
    <div className="aikyambot-wrapper">
      <button
        id="aikyam-chat-button"
        className="chat-toggle"
        aria-label="Open chat"
      >
        <img src={chat} alt="chat" className="chat-icon" />
        <span>AikyamBot</span>
      </button>
    </div>
  );
};

export default AikyamBot;